export default __webpack_public_path__ + "static/media/whatsapp_banner_headline_desktop.eb692e25.gif";